module.exports = __webpack_public_path__ + "img/icb-del-elite-m@2x.41ffc76c.png";